import React from 'react'

const Wrench = ({
  size,
  style,
  primaryColor,
  secondaryColor,
  title = 'icon/wrench',
  ...props
}) => (
  <svg height='20' width='20' viewBox='0 0 20 20' style={style} {...props}>
    <path
      d='M14.037 1.411c.315.017.634.068.942.15l1 .27-.731.733-1.86 1.867a1.536 1.536 0 0 0 0 2.19 1.537 1.537 0 0 0 2.19 0l2.594-2.603.267 1.012a4.931 4.931 0 0 1-1.257 4.714 4.781 4.781 0 0 1-3.404 1.4c-.476 0-.95-.068-1.41-.202l-.026-.007-6.997 6.997a2.3 2.3 0 0 1-1.633.677 2.3 2.3 0 0 1-1.635-.677 2.319 2.319 0 0 1 0-3.276l6.98-6.979.017-.018-.007-.025c-.5-1.72-.043-3.566 1.198-4.814a4.831 4.831 0 0 1 3.772-1.409z'
      fill='none'
      fillRule='evenodd'
      stroke={primaryColor}
      strokeWidth='1.2'
    />
  </svg>
)

export default Wrench
